import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useWhatsAppEmbeddedSignup } from "../hooks/useWhatsAppEmbeddedSignup";
export function ConnectWhatsAppButton({ disabled = false, className, flow = "new_number", label, ...options }) {
    const { status, error, loginStatus, start } = useWhatsAppEmbeddedSignup({
        ...options,
        flow,
    });
    const handleClick = () => {
        void start();
    };
    const defaultLabel = flow === "business_app"
        ? "Connect existing WhatsApp Business App"
        : "Connect WhatsApp (new number)";
    return (_jsxs("div", { children: [_jsx("button", { type: "button", className: className, disabled: disabled ||
                    status === "loading_sdk" ||
                    status === "signup_launched" ||
                    loginStatus === "exchanging_code", onClick: handleClick, children: loginStatus === "code_exchanged"
                    ? "WhatsApp connected"
                    : loginStatus === "exchange_failed"
                        ? "WhatsApp connection failed"
                        : status === "loading_sdk"
                            ? "Loading Facebook SDK..."
                            : status === "signup_launched"
                                ? "WhatsApp signup open..."
                                : (label ?? defaultLabel) }), status === "sdk_ready" && (_jsx("p", { role: "status", children: "Facebook SDK loaded. Signup flow is not implemented yet." })), status === "signup_launched" && (_jsx("p", { role: "status", children: "WhatsApp signup has been launched." })), status === "error" && error && (_jsxs("p", { role: "alert", children: ["Unable to connect WhatsApp: ", error] })), loginStatus === "code_exchanged" && (_jsx("p", { role: "status", children: "WhatsApp connection completed successfully." }))] }));
}
